import { render, staticRenderFns } from "./CommunityModal.vue?vue&type=template&id=29104eb8"
import script from "./CommunityModal.vue?vue&type=script&lang=js"
export * from "./CommunityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports